import { Descriptions } from "antd";

const CourseInfo = ({ courseDetails }) => {
  return (
    <Descriptions title="Course Details" bordered column={{ xs: 1, sm: 2, md: 3 }}>
      <Descriptions.Item label="Name">{courseDetails?.name}</Descriptions.Item>
      <Descriptions.Item label="Batch">{courseDetails?.batchName}</Descriptions.Item>
      <Descriptions.Item label="Price">
        {courseDetails?.currency} {courseDetails?.price}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default CourseInfo;
